<template lang="pug">
  .legal.has-text-left.columns
    .column.is-8
      .legal-questions
        h2.title.is-block-desktop-only.is-hidden-mobile Legal
        bulma-accordion(dropdown)
          bulma-accordion-item.legal-type(v-for="(v, k) of legals", :key="k", tabindex="-2")
            h4(slot="title") {{k}}
            p(slot="content")
              router-link.legal-option(v-for="(q, i) of v" :key="i" :to="{name: 'legal-question', params: {type: k, question: q.name.split(' ').join('_')}}") {{q.name}}
      hr.is-block-tablet.is-hidden-desktop
    .column.is-4
      .legal-contact-us
        .legal-contact-box.box
          h2.title Can't find the answer you're looking for?
          router-link.button.is-primary.legal-button.is-block-mobile.is-inline-block-desktop(to="/contact-us") CONTACT US
</template>

<script>
  import _ from 'lodash'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'

  export default {
    components: {
      BulmaAccordion,
      BulmaAccordionItem
    },
    data() {
      return {
      }
    },
    computed: {
      results() {
        return this.$store.getters.getLegal
      },
      legals() {
        return _.reduce(this.results, (r, v) => {
          (r[v.category] || (r[v.category] = [])).push(v)
          return r
        }, {})
      },
      activeLegal() {
        return _.first(this.results).id
      },
      lookup() {
        return _.reduce(this.results, (r, v) => {
          r[v.id] = v
          return r
        }, {})
      }
    },
    async mounted() {
      if (!this.results) {
        this.$store.dispatch('fetchLegal')
      }
    },
    methods: {
      isEmpty: _.isEmpty
    }
  }
</script>

<style lang="scss">
  @import "../styles/variables";
  @import "~bulma/sass/utilities/mixins";

  .legal {
    padding: 3rem;

    .legal-questions {
      .legal-type {
        background-color: rgb(250, 250, 250);
        cursor: pointer;
        // position: relative;
        font-weight: normal;
        margin: 0.2rem;
        outline: none;
        margin-bottom: 1em;

        .legal-type-name {
          text-transform: uppercase;
          display: flex;
          padding: 0.5rem 1rem;

          .legal-type-title {
            flex: 1;
          }

          .legal-icon {
            align-self: center;
          }
        }

        .legal-option {
          padding: 0.5rem 1rem;
          display: block;
          color: $secondary-colour;

          &:hover {
            background-color: $primary-colour;
            color: #FFF;
          }
        }

        .card-content {
          padding: 0;
        }
      }
    }

    .legal-contact-us {
      .legal-contact-box {

        .legal-button {
          border-radius: 0;
          padding: 1.25rem 2rem;
          line-height: 0;
        }

        @include from($desktop) {
          padding: 3rem;
        }
      }
    }
  }
</style>
